<template>
  <div class="p-grid" id="loading">
    <div class="p-col-12" v-for="itemIndex in items" :key="itemIndex">
      <Card>
        <template v-slot:content>
          <div class="p-grid" v-for="rowIndex in rows" :key="rowIndex">
            <div class="p-col" v-for="colIndex in cols" :key="colIndex">
              <Skeleton width="100%" height="23px" />
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSkeletonCardField',
  props: {
    rows: Number,
    cols: Number,
    items: {
      type: Number,
      default: () => 5,
    },
  },
};
</script>

<style lang="css" scoped>
#loading >>> .p-card-content {
  padding: 0 !important;
}
</style>
